import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('page.digital_twin.mcu');
import { OnInit } from '@angular/core';
import { Service } from "src/libs/portal/season/service";

declare let wiz: any;

const PROJECT_WORKFLOW_ID_KEY = 'actuator:lastProjectId';

@Component({
    standalone: false,
    selector: 'wiz-page-digital_twin-mcu',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/page.digital_twin.mcu/view.scss */
:host {
  display: block;
  height: 100%;
}

.twin-shell {
  background: linear-gradient(135deg, var(--twin-bg-start), var(--twin-bg-mid), var(--twin-bg-end));
  color: var(--twin-text);
  transition: background-color 180ms ease, color 180ms ease;
  --twin-bg-start: #f8fafc;
  --twin-bg-mid: #ffffff;
  --twin-bg-end: #e2e8f0;
  --twin-text: #0f172a;
  --twin-muted: #64748b;
  --twin-border: rgba(148, 163, 184, 0.36);
  --twin-card: rgba(255, 255, 255, 0.88);
}

:host-context(.dark) .twin-shell,
.twin-dark {
  --twin-bg-start: #020617;
  --twin-bg-mid: #0f172a;
  --twin-bg-end: #18181b;
  --twin-text: #f8fafc;
  --twin-muted: #94a3b8;
  --twin-border: rgba(255, 255, 255, 0.1);
  --twin-card: rgba(15, 23, 42, 0.62);
}

.twin-light [class*="border-white/"] {
  border-color: var(--twin-border) !important;
}

.twin-light [class*=bg-slate-950],
.twin-light [class*="bg-white/5"] {
  background-color: var(--twin-card) !important;
}

.twin-light [class*=bg-slate-800] {
  background-color: #e2e8f0 !important;
}

.twin-light .text-white,
.twin-light .text-slate-100,
.twin-light .text-slate-200 {
  color: var(--twin-text) !important;
}

.twin-light .text-slate-300,
.twin-light .text-slate-400,
.twin-light .text-slate-500 {
  color: var(--twin-muted) !important;
}

.twin-light .text-cyan-100,
.twin-light .text-cyan-200,
.twin-light .text-cyan-300 {
  color: #0e7490 !important;
}

.twin-light .text-emerald-100,
.twin-light .text-emerald-200,
.twin-light .text-emerald-300,
.twin-light .text-emerald-400 {
  color: #047857 !important;
}

.twin-light .text-amber-100,
.twin-light .text-amber-200,
.twin-light .text-amber-300 {
  color: #b45309 !important;
}

.twin-light .text-orange-100,
.twin-light .text-orange-200,
.twin-light .text-orange-300 {
  color: #c2410c !important;
}

.twin-light tbody tr:hover {
  background-color: rgba(241, 245, 249, 0.72) !important;
}`],
})
export class PageDigital_twinMcuComponent implements OnInit {
    constructor(@Inject( Service) public service: Service) {}

    public theme: 'light' | 'dark' = 'light';
    public projectId: string = '';

    public mcuResult: any = null;
    public mcuReport: any = null;
    public isComparingMcu: boolean = false;
    public isSavingMcu: boolean = false;
    public mcuError: string = '';
    public mcuNotice: string = '';
    public fieldRows: any[] = [];
    public fieldForm: any = this.defaultFieldForm();
    public isLoadingField: boolean = false;
    public isSavingField: boolean = false;
    public isSeedingField: boolean = false;
    public fieldError: string = '';
    public fieldNotice: string = '';

    public async ngOnInit() {
        await this.service.init();
        this.projectId = this.routeProjectId();
        this.rememberProjectId(this.projectId);
        this.syncGlobalTheme();
        await this.loadMcuComparison();
        await this.loadFieldSamples();
        await this.service.render();
    }

    private syncGlobalTheme() {
        try {
            const saved = localStorage.getItem('appTheme');
            this.theme = saved === 'dark' ? 'dark' : 'light';
        } catch (e) { this.theme = 'light'; }
    }

    private routeProjectId(): string {
        const params = new URLSearchParams(location.search);
        const queryId = params.get('project_id') || '';
        if (queryId) return queryId;
        try {
            return localStorage.getItem(PROJECT_WORKFLOW_ID_KEY) || '';
        } catch (e) {
            return '';
        }
    }

    private rememberProjectId(id: string) {
        if (!id) return;
        try {
            localStorage.setItem(PROJECT_WORKFLOW_ID_KEY, id);
        } catch (e) {}
    }

    public digitalTwinToolUrl(path: string): string {
        return this.projectId ? `${path}?project_id=${encodeURIComponent(this.projectId)}` : path;
    }

    public projectDigitalTwinUrl(): string {
        return this.projectId ? `/projects/${encodeURIComponent(this.projectId)}/digital_twin` : '/projects';
    }

    public goDigitalTwinTool(path: string) {
        this.service.href(this.digitalTwinToolUrl(path));
    }

    public goProjectDigitalTwin() {
        this.service.href(this.projectDigitalTwinUrl());
    }

    public goReport(report: any) {
        const id = report?.id || this.mcuReport?.id || '';
        if (!id) return;
        this.service.href(`/reports/${encodeURIComponent(id)}`);
    }

    public defaultFieldForm(): any {
        return {
            cycle_no: 1,
            time_ms: 0,
            voltage: 12.4,
            current: 5.2,
            hall_count: 1000,
            speed: 22,
            position: 0,
            temperature: 25,
            load: 40
        };
    }

    public getDeviationColor(deviation: number): string {
        if (deviation > 20) return this.theme === 'dark' ? 'text-orange-200' : 'text-orange-700';
        if (deviation > 10) return this.theme === 'dark' ? 'text-amber-200' : 'text-amber-700';
        return this.theme === 'dark' ? 'text-cyan-200' : 'text-cyan-700';
    }

    public async loadMcuComparison() {
        if (this.isComparingMcu) return;
        this.isComparingMcu = true;
        this.mcuError = '';
        this.mcuNotice = '';
        await this.service.render();
        try {
            const { code, data } = await wiz.call("mcu_sim_preview", this.mcuRequestParams());
            if (code === 200) {
                this.mcuResult = { type: 'comparison', data };
                this.mcuReport = data?.report || null;
            }
            else { this.mcuError = data?.message || 'MCU vs 시뮬레이션 비교 결과를 불러오지 못했습니다.'; }
        } catch (e) {
            this.mcuError = 'MCU vs 시뮬레이션 비교 결과를 불러오지 못했습니다.';
        }
        this.isComparingMcu = false;
        await this.service.render();
    }

    public async runMcuValidation() {
        if (this.isSavingMcu) return;
        this.isSavingMcu = true;
        this.mcuError = '';
        this.mcuNotice = '';
        await this.service.render();
        try {
            const { code, data } = await wiz.call("compare_mcu_sim", this.mcuRequestParams());
            if (code === 200) {
                this.mcuResult = { type: 'comparison', data };
                this.mcuReport = data?.report || null;
                this.mcuNotice = data?.reportId ? 'MCU 비교 검증 리포트가 생성되었습니다.' : 'MCU 비교 검증이 완료되었습니다.';
            }
            else { this.mcuError = data?.message || 'MCU 비교 검증을 실행하지 못했습니다.'; }
        } catch (e) {
            this.mcuError = 'MCU 비교 검증을 실행하지 못했습니다.';
        }
        this.isSavingMcu = false;
        await this.service.render();
    }

    public async loadFieldSamples() {
        if (!this.projectId || this.isLoadingField) return;
        this.isLoadingField = true;
        this.fieldError = '';
        await this.service.render();
        try {
            const { code, data } = await wiz.call("field_samples", { project_id: this.projectId, dump: 20 });
            if (code === 200) this.fieldRows = data?.rows || [];
            else this.fieldError = data?.message || '실측 데이터 목록을 불러오지 못했습니다.';
        } catch (e) {
            this.fieldError = '실측 데이터 목록을 불러오지 못했습니다.';
        }
        this.isLoadingField = false;
        await this.service.render();
    }

    public async saveFieldSample() {
        if (!this.projectId || this.isSavingField) return;
        this.isSavingField = true;
        this.fieldError = '';
        this.fieldNotice = '';
        await this.service.render();
        try {
            const { code, data } = await wiz.call("ingest_field_sample", {
                project_id: this.projectId,
                ...this.fieldForm
            });
            if (code === 200) {
                const row = data?.rows?.[0] || {};
                this.fieldNotice = `실측 데이터가 저장되었습니다. 품질 ${row.quality_score ?? '-'}점`;
                this.fieldForm = { ...this.fieldForm, time_ms: Number(this.fieldForm.time_ms || 0) + 75 };
                await this.loadFieldSamples();
                await this.loadMcuComparison();
            }
            else this.fieldError = data?.message || '실측 데이터를 저장하지 못했습니다.';
        } catch (e) {
            this.fieldError = '실측 데이터를 저장하지 못했습니다.';
        }
        this.isSavingField = false;
        await this.service.render();
    }

    public async seedFieldDemo() {
        if (!this.projectId || this.isSeedingField) return;
        this.isSeedingField = true;
        this.fieldError = '';
        this.fieldNotice = '';
        await this.service.render();
        try {
            const { code, data } = await wiz.call("seed_field_demo", { project_id: this.projectId });
            if (code === 200) {
                this.fieldNotice = `필드 센서 데모 데이터 ${data?.count || 0}건이 적재되었습니다.`;
                await this.loadFieldSamples();
                await this.loadMcuComparison();
            }
            else this.fieldError = data?.message || '필드 센서 데모 데이터를 적재하지 못했습니다.';
        } catch (e) {
            this.fieldError = '필드 센서 데모 데이터를 적재하지 못했습니다.';
        }
        this.isSeedingField = false;
        await this.service.render();
    }

    private mcuRequestParams(): any {
        return {
            project_id: this.projectId,
            weight: 12, voltage: 12, temperature: 25,
            cogX: 0.15, cogY: 0.0, cogZ: -0.02,
            hingeX: 0.0, hingeY: 0.0, hingeZ: 0.0,
            mountX: 0.05, mountY: 0.12, mountZ: -0.03,
            targetAngle: 80, targetTime: 3.5
        };
    }
}

export default PageDigital_twinMcuComponent;